export default class Configuration {
  static get EnvConfig() {

    return {
      VUE_APP_BASE_URI: "$VUE_APP_BASE_URI",
      VUE_APP_WEBAPI: "$VUE_APP_WEBAPI",
      VUE_APP_I18N_LOCALE: "$VUE_APP_I18N_LOCALE",
      VUE_APP_I18N_FALLBACK_LOCALE: "$VUE_APP_I18N_FALLBACK_LOCALE",
      VUE_APP_CAMPAIGN_MINIMUM_DURATION_INDAYS:
      "$VUE_APP_CAMPAIGN_MINIMUM_DURATION_INDAYS",
      VUE_APP_WIJMO_LICENCE: "$VUE_APP_WIJMO_LICENCE",
    };

  }
  static value(key) {    
    // Get the value
    const value = this.EnvConfig[key];

    // If the value is null, return  https://dm-webapi.amr-integration.green.intra/  https://localhost:44363/
    if (!value) {
      console.error(`Configuration: Value for "${key}" is not defined`);
      return;
    }

    return value;
  }
}
